/**
 * Dev environment
 *
 * Put what you like in it, but DON'T use it to build prod !
 */
export const environment = {
  production: false,
  api: 'https://chat-api-new-pp.contactdve.com/api',
  graphQL: 'https://api.pp.weezchat.fr/graphql',
  chat: 'https://pp-chat-liveengine.contactdve.com/',

  waitingAPI: 'dating-notification-pp.dv-content.io/',
  waitingToken: 'TtD4dFtMCfu92eCK',
  gtm: 'GTM-NL85VR6',
  gtmCountry: 'GTM-5TLGTTR',
  completeProfileInputs: ['phoneNumber'],
  id: 'ckcg8gngc2p9g0b62aymc72cp',
  dvp4m: true,
  gsv: null,

  appLink: null,
  didomi: null,
};
